




































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Icon, { IconEnum } from '@/modules/shared/components/icon.component.vue';

@Component({
  components: {
    Icon,
  },
})
export default class Avatar extends Vue {
  @Prop({ default: '' }) private imageUrl!: string;
  @Prop({ default: '' }) private avatarText!: string;
  @Prop({ default: false }) private readOnly!: boolean;


  private iconEnum = IconEnum;
  private url = '';

  @Watch('imageUrl')
  private watchImageUrl(newVal: string, oldVal: string) {
    if ( newVal ) {
      this.url = newVal;
    }
  }


  private created() {
    if ( this.imageUrl ) {
      this.url = this.imageUrl;
    }
  }

  get hasImage() {
    return this.imageUrl !== '';
  }

  get hasUrl() {
    return this.url !== '';
  }


  private handleClick() {
    if ( !this.readOnly && !this.hasUrl ) {
      (this.$refs.inputFile as HTMLElement).click();
    }
  }

  private handleFileChange(e: any) {
    const file = e.target.files[0];
    if ( file ) {
      this.url = URL.createObjectURL(file);
      this.$emit('change-image', file);
    }
  }

  private removeImage(e: any) {
    e.stopPropagation();
    this.url = '';
    this.$emit('remove-image');
  }

}

